import { type Tax } from '@webapp/platform/finance'

export type StaticExpenseTaxOption = {
  id: '%' | '$'
  name: string
}

export type ExpenseTaxSelectValue = Tax | StaticExpenseTaxOption

export const isPresetTax = (opt: Nullable<ExpenseTaxSelectValue>): opt is Tax =>
  typeof opt?.id === 'number'
